import React from 'react';
import ChipIndicator from './ChipIndicator';
import Typography from 'Components/DesignSystem/Typography/Typography';

type TDisplayProps = {
    showChip?: boolean;
    displayText: string;
    value: string;
    'data-testid'?: string;
}

/**
 * The "Estimated sessions / orders per day" read-out pair (§ 146).
 *
 * Two `<label>` elements with no `htmlFor`, one of them being the VALUE — a labelling
 * element used as data. Both are `Typography` now, and the box takes `surface-sunken`
 * inside an `edge` border instead of `tw-bg-gray-100 tw-border-zinc-300`, neither of
 * which is a design-system colour (`zinc` is a stock Tailwind ramp that deep-merges in;
 * see the tokenDiscipline guard).
 *
 * `showChip` remains dead — its only caller is the commented-out "Test duration" box in
 * `ScheduleSection`. Kept because `ChipIndicator` is otherwise orphaned and deleting
 * both is a separate decision from this restyle.
 */
const DisplayBox = ({ showChip = false, displayText, value, 'data-testid': dataTestId }: TDisplayProps) => {
    return (
        <div
            className="tw-w-auto tw-h-auto tw-bg-surface-sunken tw-rounded-ctl tw-border tw-border-edge tw-p-2"
            data-testid={dataTestId}
        >
            <div className="tw-flex tw-items-center tw-gap-2">
                <Typography variant="title" as="p" className="tw-text-ink-tertiary">{displayText}</Typography>
                {showChip ? <ChipIndicator /> : null}
            </div>
            <Typography
                variant={showChip ? 'heading-2' : 'title-header'}
                as="p"
                className="tw-text-ink tw-mt-4"
                data-testid={dataTestId ? `${dataTestId}-value` : undefined}
            >
                {value}
            </Typography>
        </div>
    );
}

export default DisplayBox;
